import React, { Fragment } from "react";
import { getCellInventoryById, getLinkInventoryById } from "../../api/index";
import { Button, Row, Select, Table, Collapse, Spin, Typography } from "antd";
import NoData from './assets/noData.svg';

const { Title } = Typography;
const { Panel } = Collapse;

const N360 = ({ siteID }) => {
    const [selectedInventory, setSelectedInventory] = React.useState('Cell_Inventory');
    const [inventoryData, setInventoryData] = React.useState({});
    const [loading, setLoading] = React.useState(false);

    const dropDownMap = [
        { id: '1', name: 'Cell Inventory', dataIndexInAPI: 'Cell_Inventory' },
        { id: '2', name: 'Link Inventory', dataIndexInAPI: 'Link_Inventory' }
    ];

    React.useEffect(() => {
        fetchInventoryData(selectedInventory);
    }, [selectedInventory]);

    const fetchInventoryData = async (inventoryType) => {
        setLoading(true);
        try {
            let response;
            if (inventoryType === 'Cell_Inventory') {
                response = await getCellInventoryById(siteID);
            } else if (inventoryType === 'Link_Inventory') {
                response = await getLinkInventoryById(siteID);
            }
            if (response.success) {
                let dataIndexInAPI = dropDownMap.find(item => item.dataIndexInAPI === inventoryType)?.dataIndexInAPI;
                setInventoryData(response?.data?.Response?.[dataIndexInAPI] || {});
            }
        } catch (error) {
            // Optionally handle error
        } finally {
            setLoading(false);
        }
    };

    return (
        <Spin spinning={loading} tip="Loading Data...">
            <Fragment>
                <div style={{ marginTop: '20px', backgroundColor: 'white', borderRadius: '5px', padding: '10px', zIndex: 10 }}>
                    <Row>
                        {dropDownMap.map(item => (
                            <Button
                                key={item.id}
                                onClick={() => setSelectedInventory(item.dataIndexInAPI)}
                                style={{
                                    backgroundColor: selectedInventory === item.dataIndexInAPI ? '#F5E5E8' : 'white',
                                    borderColor: selectedInventory === item.dataIndexInAPI ? '#B9183A' : 'gray',
                                    fontSize: 15,
                                    width: '47%',
                                    height: '40px',
                                    borderRadius: '5px',
                                    marginRight: '1%'
                                }}
                            >
                                <span className='textStyles-small' style={{ fontSize: 13, fontWeight: 500, color: selectedInventory === item.dataIndexInAPI ? '#B9183A' : 'black' }}>
                                    {item.name}
                                </span>
                            </Button>
                        ))}
                    </Row>
                </div>
            </Fragment>

            {inventoryData && Object.entries(inventoryData).length > 0 ? (
                Object.entries(inventoryData).map(([sectionName, sectionData]) => {
                    if (!Array.isArray(sectionData) || sectionData.length === 0) {
                        return (
                            <div style={{ backgroundColor: 'white', padding: 10, marginTop: 10, borderRadius: 10 }} id={sectionName} key={sectionName}>
                                <Collapse ghost={true}>
                                    <Panel header={<span className='txtStyles-small' style={{ fontSize: 13, fontWeight: 'bold' }} >{sectionName}</span>} key="1">
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 170 }}>
                                            <img src={NoData} alt="No Data" style={{ width: 120, height: 170 }} />
                                        </div>
                                    </Panel>
                                </Collapse>
                            </div>
                        );
                    }
                    const columns = Object.keys(sectionData[0]).map((key) => ({
                        title: key.replace(/_/g, " "),
                        dataIndex: key,
                        key,
                    }));
                    return (
                        <div style={{ backgroundColor: 'white', padding: 10, marginTop: 10, borderRadius: 10 }} key={sectionName}>
                            <Collapse ghost={true} defaultActiveKey={['1']}>
                                <Panel header={<span className='txtStyles-small' style={{ fontSize: 13, fontWeight: 'bold' }} >{sectionName}</span>} key="1">
                                    <Table
                                        columns={columns}
                                        dataSource={sectionData.map((item, idx) => ({ ...item, key: idx }))}
                                        pagination={sectionData.length > 10 ? { pageSize: 10 } : false}
                                        bordered
                                        scroll={{ x: 'max-content' }}
                                        className="table-striped-rows textStyles-small"
                                    />
                                </Panel>
                            </Collapse>
                        </div>
                    );
                })
            ) : (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 170 }}>
                    <img src={NoData} alt="No Data" style={{ width: 120, height: 170 }} />
                </div>
            )}
        </Spin>
    );
};

export default N360;